import { useEffect, useRef } from 'react';

interface IMIState {
    subscribe: (prop: string, callback: (newState: any, oldState: any) => void) => void;
    getState: (prop?: string) => any;
}

export function useMIState() {
    //@ts-ignore
    const MIState = useRef<IMIState>(window.MI.state);
    const state = useRef<any>();

    useEffect(() => {
        MIState.current.subscribe('', (newState, oldState) => {
            state.current = MIState.current.getState();
        });
        state.current = MIState.current.getState();
    }, [MIState]);

    return state.current;
}
